import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Header from './Header';
import Footer from './Footer';
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Navigation, Pagination } from 'swiper/modules';
import VisaForm from "./VisaForm";
import NotFound from './NotFound';

function VisaDetails() {
 const { slug } = useParams();
  const [visdetails, setvisdetails] = useState(null);
  const [loading, setLoading] = useState(true);
      const [notFound, setNotFound] = useState(false);
  const [selectedVisa, setSelectedVisa] = useState(null);
  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "inr");


  useEffect(() => {
    const updateCurrency = () => {
      setCurrency(localStorage.getItem("currency") || "inr");
    };

    window.addEventListener("currency-change", updateCurrency);
    return () => window.removeEventListener("currency-change", updateCurrency);
  }, []);

  const getPrice = (item) => {
    if (!item) return "";

    if (currency === "usd") return `$${item.price_usd}`;
    if (currency === "aed") return `AED ${item.price_aed}`;
    return `₹${item.price_inr}`;
  };
useEffect(() => {
  if (!slug) return;

  setLoading(true);
  setNotFound(false);

  fetch(`https://planjourneysglobal.com/admin/api/visa_detail/${slug}`)
    .then((res) => res.json())
    .then((data) => {

      const visaData = data?.data;

      if (
        data?.status &&
        visaData &&
        Object.keys(visaData).length > 0
      ) {
        setvisdetails(visaData);

        // Auto-select first visa category safely
        let visaCatsData = [];

        if (visaData.visa_categories) {
          visaCatsData =
            typeof visaData.visa_categories === "string"
              ? JSON.parse(visaData.visa_categories)
              : visaData.visa_categories;
        }

        if (visaCatsData.length > 0) {
          setSelectedVisa(visaCatsData[0]);
        }

      } else {
        setvisdetails(null);
        setNotFound(true);
      }

      setLoading(false);
    })
    .catch((err) => {
      console.error("Fetch Error:", err);

      setvisdetails(null);
      setNotFound(true);

      setLoading(false);
    });

}, [slug]);

  // --- Parse categories and FAQ safely using visdetails state ---
  const visaCats = visdetails?.visa_categories
    ? typeof visdetails.visa_categories === "string"
      ? JSON.parse(visdetails.visa_categories)
      : visdetails.visa_categories
    : [];

  const visaFaq = visdetails?.faq
    ? typeof visdetails.faq === "string"
      ? JSON.parse(visdetails.faq)
      : visdetails.faq
    : [];
    const validFaqs = visaFaq.filter(
  item =>
    item?.question?.trim() &&
    item?.answer?.trim()
);
if (loading) return <p></p>;

if (notFound) return <NotFound />;




    return(

        <>
          <Helmet>
       {/* <title>{visdetails.meta_title}</title> 
       <meta name="description" content={visdetails.meta_description} /> */}
       {visdetails.meta_keyword && <meta name="keywords" content={visdetails.meta_keyword} />}
       {/* {visdetails.slug && <link rel="canonical" href={visdetails.slug} />}
 
    
       <meta property="og:title" content={visdetails.meta_title} />
       <meta property="og:description" content={visdetails.meta_description} />
       {visdetails.image && <meta property="og:image" content={visdetails.image} />}
       {visdetails.slug && <meta property="og:url" content={visdetails.slug} />}
       <meta property="og:type" content="website" />
 
   
       <meta name="twitter:title" content={visdetails.meta_title} />
       <meta name="twitter:description" content={visdetails.meta_description} />
       {visdetails.image && <meta name="twitter:image" content={visdetails.image} />}
       <meta name="twitter:card" content="summary_large_image" /> */}
     </Helmet>
        <Header/>
<>

 {/* Breadcrumb section Start*/}
  <div className="breadcrumb-section two">
    <div className="swiper home2-banner-slider">
     <Swiper className="swiper-wrapper"
      modules={[Pagination]}
      pagination={{ clickable: true }}
      slidesPerView={1}
       spaceBetween={0}
      loop={true}
    >
        <SwiperSlide className="swiper-slide">
          <div
            className="banner-bg">
 <img
                    src={`https://planjourneysglobal.com/admin/${visdetails.banner_image}`}
                    alt={visdetails.country_name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/img/no-image.png";
                    }}
                  />

          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div className="banner-content-wrap">
      <div className="container">
        <div className="banner-content">
         
           <h1>{visdetails.country_name}</h1>
        
        </div>
      </div>
    </div>
  
  </div>




  {/* Visa Details Start*/}
  <div className="visa-details-page pt-100 mb-100 mt-30">
    <div className="container">
      <div className="visa-list-area mb-0">
        <div className="swiper visa-dt-visa-list-slider">
        <Swiper
      className="swiper-wrapper"
        modules={[Navigation, Pagination]}
        spaceBetween={10}
        slidesPerView={6}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
      >  {visaCats.map((item, index) => (
  <SwiperSlide className="swiper-slide" key={index}>
   <div
          className={`single-visa ${selectedVisa?.id === item.id ? "active" : ""}`}
          onClick={() => setSelectedVisa(item)}
        >
      <img src={`https://planjourneysglobal.com/admin/${item.image}`} width={36} height={36} alt={item.name} />
      <h6>{item.name}</h6>
      <span>
        <span>{getPrice(item)}</span> <sub>/per person</sub>
      </span>
    </div>
  </SwiperSlide>
))}


          </Swiper>
        </div>
      </div>
      <div className="row gy-5 justify-content-between">
        <div className="col-xl-7 col-lg-8">
          
          <div className="visa-details-wrapper active">
            <div className="single-requirement mb-50">
                        <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.document_requirement
              }}
            ></div>
            </div>
            <div className="single-requirement mb-50">
                <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.additional_requirement
              }}
            ></div>
             
            </div>
            <div className="single-requirement mb-50">
              <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.conditional_requirement
              }}
            ></div>
            </div>
            <div className="visa-rejection-area mb-50 d-none">
              
              <div className="visa-rejection-wrapper">
                <div className="visa-rejection-content">
                 <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.visa_rejection_reasons
              }}
            ></div>
                </div>
                <div className="visa-rejection-img">
                  <img
                    src="/assets/img/innerpages/visa-rejection-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="note-area">
               <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.important_note
              }}
            ></div>
            
            </div>
          </div>
          <div className="visa-details-wrapper">
            <div className="single-requirement mb-50">
               <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.important_note
              }}
            ></div>
            
            </div>
            
          
            <div className="visa-rejection-area mb-50">
              
              <div className="visa-rejection-wrapper">
                <div className="visa-rejection-content">
                   <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.visa_rejection_reasons
              }}
            ></div>
              
                </div>
                <div className="visa-rejection-img">
                  <img
                    src="/assets/img/innerpages/visa-rejection-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="note-area">
        
             <div
              className="document-content"
              dangerouslySetInnerHTML={{
                __html: visdetails.Rejection
              }}
            ></div>
            </div>
          </div>
        
        </div>
        <div className="col-lg-4 col-md-8 cardsdetasis">
            
          <div className="card">
             <div className="card">
             <div className="card-body enquiry">
           <h3>Enquiry Form</h3>
           </div>
</div>
             <div className="card-body">
      {visdetails && (
        <VisaForm 
          countryName={visdetails.country_name} 
          visaId={visdetails.id} 
        />
      )}
</div>
</div>
          <div className="visa-dt-sidebar">
              {selectedVisa && (
                <div className="visa-info-wrap active">
                  <div className="title-area">
                    <h4>{selectedVisa.name}</h4>
                    <span>Validity- {selectedVisa.validity}</span>
                  </div>

                  <div className="pricing-area">
                    <span>Visa Pricing</span>
                    <strong>
                       {getPrice(selectedVisa)}
                      <sub>/per person</sub>
                    </strong>
                  </div>

                  <a href="/contact" className="primary-btn1">
                    <span>Apply Online</span>
                    <span>Apply Online</span>
                  </a>

                  <span>
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 0C3.13423 0 0 3.13423 0 7C0 10.8662 3.13423 14 7 14C10.8662 14 14 10.8666 14 7C14 3.13423 10.8662 0 7 0ZM7 12.6875C3.85877 12.6875 1.31252 10.1412 1.31252 7C1.31252 3.85877 3.85877 1.31252 7 1.31252C10.1412 1.31252 12.6875 3.85877 12.6875 7C12.6875 10.1412 10.1412 12.6875 7 12.6875ZM7.00044 3.06992C6.49908 3.06992 6.11973 3.33157 6.11973 3.75418V7.63042C6.11973 8.05347 6.49903 8.31423 7.00044 8.31423C7.48956 8.31423 7.88115 8.04256 7.88115 7.63042V3.75418C7.8811 3.3416 7.48956 3.06992 7.00044 3.06992ZM7.00044 9.1875C6.51875 9.1875 6.12673 9.57952 6.12673 10.0616C6.12673 10.5428 6.51875 10.9349 7.00044 10.9349C7.48212 10.9349 7.87371 10.5428 7.87371 10.0616C7.87366 9.57948 7.48212 9.1875 7.00044 9.1875Z" />
                    </svg>
                    Exclusive Offers – Access travel, dining, and shopping deals.
                  </span>
                </div>
              )}
        

            <div className="visa-assistance-wrap mt-40">
              <div className="visa-assistance-content">
                <h4>Need Visa Assistance?</h4>
                <ul>
                  <li>
                    <svg
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width={16} height={16} rx={8} />
                      <path d="M11.6947 6.45771L7.24644 10.9083C7.17556 10.9768 7.08572 11.0123 6.99596 11.0123C6.9494 11.0124 6.90328 11.0033 6.86027 10.9854C6.81727 10.9676 6.77822 10.9414 6.7454 10.9083L4.3038 8.46675C4.16436 8.32963 4.16436 8.10515 4.3038 7.96571L5.16652 7.10059C5.29892 6.96827 5.53524 6.96827 5.66764 7.10059L6.99596 8.42891L10.3309 5.09155C10.3638 5.05862 10.4028 5.03249 10.4457 5.01465C10.4887 4.9968 10.5347 4.98759 10.5812 4.98755C10.6757 4.98755 10.7656 5.02539 10.8317 5.09155L11.6944 5.95675C11.8341 6.09619 11.8341 6.32067 11.6947 6.45771Z" />
                    </svg>
                    Expert Guidance
                  </li>
                  <li>
                    <svg
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width={16} height={16} rx={8} />
                      <path d="M11.6947 6.45771L7.24644 10.9083C7.17556 10.9768 7.08572 11.0123 6.99596 11.0123C6.9494 11.0124 6.90328 11.0033 6.86027 10.9854C6.81727 10.9676 6.77822 10.9414 6.7454 10.9083L4.3038 8.46675C4.16436 8.32963 4.16436 8.10515 4.3038 7.96571L5.16652 7.10059C5.29892 6.96827 5.53524 6.96827 5.66764 7.10059L6.99596 8.42891L10.3309 5.09155C10.3638 5.05862 10.4028 5.03249 10.4457 5.01465C10.4887 4.9968 10.5347 4.98759 10.5812 4.98755C10.6757 4.98755 10.7656 5.02539 10.8317 5.09155L11.6944 5.95675C11.8341 6.09619 11.8341 6.32067 11.6947 6.45771Z" />
                    </svg>
                    Fast Processing
                  </li>
                </ul>
                <div className="contact-area">
                  <div className="icon">
                    <img
                      src="/assets/img/innerpages/icon/whatsapp-icon-white.svg"
                      alt=""
                    />
                  </div>
                  <div className="content">
                    <span>WhatsApp</span>
                    <a href="tel:971569825050">+971 569825050</a>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Visa Details End*/}
  {/* Visa Details Success Story Section Start*/}
  <div className="visa-dt-success-story-section mb-100 d-none">
    <div className="container">
      <div
        className="section-title two mb-50 wow animate fadeInDown"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <h2>We’ve Success Stories</h2>
        <p>
          We’re committed to offering more than just products—we provide
          exceptional experiences.
        </p>
      </div>
    </div>
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="swiper destionation-dt-customer-gallery-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img1.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                    <div className="success-story-content">
                      <h5>“Exceptional service with clear guidance.”</h5>
                      <div className="author-info">
                        <h6>Mrs. Emily Patowary</h6>
                        <span>USA Student</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img2.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img3.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                    <div className="success-story-content">
                      <h5>
                        “Fast response, accurate documentation, &amp; friendly
                        service.”
                      </h5>
                      <div className="author-info">
                        <h6>Mrs. Emelia Jong</h6>
                        <span>UK Student</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img4.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <div className="video-area">
                    <video
                      autoPlay=""
                      loop=""
                      muted=""
                      playsInline=""
                      src="/assets/video/visa-details-video.mp4"
                    />
                  </div>
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                    <div className="success-story-content">
                      <h5>
                        “Got my visa approved faster than expected.
                        Recommended!”
                      </h5>
                      <div className="author-info">
                        <h6>Mrs. Emily Patowary</h6>
                        <span>Czech Republic Student</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img6.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="success-story-card">
                  <img
                    src="/assets/img/innerpages/visa-dt-success-story-card-img5.jpg"
                    alt=""
                  />
                  <div className="success-story-content-wrap">
                    <img
                      src="/assets/img/innerpages/visa-dt-success-story-card-logo.svg"
                      alt=""
                    />
                    <div className="success-story-content">
                      <h5>“Outstanding response with precise direction.”</h5>
                      <div className="author-info">
                        <h6>Mrs. Emelia Jong</h6>
                        <span>UK Student</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Visa Details Success Story Section End*/}
  {/* Faq Section Start*/}
  
 {validFaqs.length > 0 && (
  <div className="home1-faq-section mb-100">
    <div className="container">
      <div className="row justify-content-center mb-50">
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            <h2>Questions &amp; Answer</h2>
            <p>
              We’re committed to offering more than just products—we provide
              exceptional experiences.
            </p>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-xl-8 col-lg-10">
          <div className="faq-wrap">
            <div className="accordion accordion-flush" id="accordionFlushExample">

              {validFaqs.map((item, index) => {
                const headingId = `flush-heading-${index}`;
                const collapseId = `flush-collapse-${index}`;

                return (
                  <div className="accordion-item" key={index}>
                    <h5 className="accordion-header" id={headingId}>
                      <button
                        className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded={index === 0}
                        aria-controls={collapseId}
                      >
                        {item.question}
                      </button>
                    </h5>

                    <div
                      id={collapseId}
                      className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                      aria-labelledby={headingId}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {item.answer}
                      </div>
                    </div>
                  </div>
                );
              })}

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}


  {/* Faq Section End*/}
</>
<Footer/> 
        </>

        
    )
}
export default VisaDetails;